import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { StratifyDocument } from "@stratify/shared";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectProperties } from "../../../../properties/store/propertiesSelectors";
import { updateDocumentAddressStart } from "../../../store/documentsSlice";

interface PropertyAddressSelectProps {
  document: StratifyDocument;
}

export const PropertyAddressSelect: React.FC<PropertyAddressSelectProps> = ({
  document,
}) => {
  const dispatch = useDispatch();
  const properties = useSelector(selectProperties);
  const [editedAddress, setEditedAddress] = useState(
    document.metadata.address || ""
  );

  const handleChange = (event: SelectChangeEvent) => {
    const newAddress = event.target.value;
    setEditedAddress(newAddress);
    dispatch(
      updateDocumentAddressStart({
        documentId: document.id,
        address: newAddress,
      })
    );
  };

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="address-select-label">Address</InputLabel>
      <Select
        data-testid="document-address"
        labelId="address-select-label"
        id="address-select"
        value={editedAddress}
        label="Address"
        onChange={handleChange}
      >
        <MenuItem value={editedAddress}>{editedAddress || "-"}</MenuItem>
        {properties
          .filter((property) => property.address !== editedAddress)
          .map((property) => (
            <MenuItem key={property.id} value={property.address}>
              {property.address}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
